import type { ButtonHTMLAttributes } from "react"
import clsx from "clsx"

export interface TagChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
  slug: string
  active?: boolean
  onClick?: () => void
  className?: string
}

export function TagChip({ slug, active, onClick, className, ...rest }: TagChipProps) {
  const cls = clsx(active ? "tag-badge-accent" : "tag-badge", onClick && "cursor-pointer", className)
  if (onClick) {
    return (
      <button type="button" className={cls} onClick={onClick} {...rest}>{slug}</button>
    )
  }
  return <span className={cls}>{slug}</span>
}
